"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidEpoch = void 0;
const CademyError_1 = __importDefault(require("../../../CademyError"));
class InvalidEpoch extends CademyError_1.default {
    constructor(detail, status) {
        super('generic/invalid-epoch', 'Invalid Epoch', detail, status);
    }
}
exports.InvalidEpoch = InvalidEpoch;
exports.default = InvalidEpoch;
